import keyMirror from 'keymirror';

export default keyMirror({
  // Example nav actions
  REGISTER_SECTION: null,
  UNREGISTER_SECTION: null,

  // Locale actions
  TOGGLE_LOCALE: null,
});
